import { ToolbarModuleExtension } from '@blocksuite/hive-shared/services';
import { BlockFlavourIdentifier } from '@blocksuite/std';

import { builtinInlineReferenceToolbarConfig } from './reference-node/configs/toolbar';

export const referenceNodeToolbar = ToolbarModuleExtension({
  id: BlockFlavourIdentifier('hive:reference'),
  config: builtinInlineReferenceToolbarConfig,
});
